import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(query) {
    return await requestWrapper(null, 'GET', `/requirements`, query);
  },
  async create(req) {
    return await requestWrapper(null, 'POST', '/requirements', null, req);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/requirements/${id}`);
  },
  async getBySection(obj) {
    const link = obj.part_id ? `${obj.id}/${obj.part_id}` : `${obj.id}`;
    return await requestWrapper(null, 'GET', `/requirements/doc/${link}`);
  },
  async update(req) {
    return await requestWrapper(null, 'PUT', `/requirements/${req.id}`, null, req);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/requirements/${id}`);
  },
};
